 

export function validateForm() {
  // Find all input fields that need to be validated and validate them
  var formElementsToValidate = document.querySelectorAll('[data-validate-on-submit]');

  var check = true;
  formElementsToValidate.forEach(function (formField) {
    if(!validateInputField(formField)){
      check = false;
    }
  })

  if(!check){
    document.getElementById("failed-to-validate").hidden = false;
    return false;
  } else {
    document.getElementById("failed-to-validate").hidden = true;
    return true;
  }
}


window.validateInputField = (inputField) => {
    inputField.style.borderColor=""
  
    var inputValue = inputField.value.trim(); // Removes spaces from beginning and end.
  
    var failedValidation = false;
    var failedABCUrlValidation = false;
  
    if(inputField.required === true && (inputValue.length === 0 || inputField.value === undefined)){
      //alert('Required field cannot be empty')
      faled = true;
    } else {
      if(inputField.getAttribute('data-no-spaces')){
        // Check input value for spaces
        if(!noSpacesValidation(inputValue)){
          failedValidation = true;
        }
      }
  
      if(inputField.getAttribute('data-no-special')){
        // Check input value for special characters
        if(!noSpecialCharacterValidation(inputValue)){
          failedValidation = true;
        }
      }

      if(inputField.getAttribute('data-alphanumeric-underscore-hyphen')){
        // Check input value for special characters
        if(!alphanumericUnderscoreHyphenValidation(inputValue)){
          failedValidation = true;
        }
      }
  
      // Checks for empty string since only the first url is required.
      if (inputField.getAttribute('data-is-abc-url') && inputField.value!=="") {
        // Check input value for abc url
        if(!isValidURL(inputValue)){
          failedValidation = true;
        }
        if(!isValidABCURL(inputValue)){
          failedValidation = true;
          failedABCUrlValidation = true;
        }
      }
    }

    var id = inputField.getAttribute('id');
    var inputHelpText = document.getElementById(id+"-help-text");

    // The additional url's don't have an id to base the help-text on.
    if(inputField.getAttribute("data-is-abc-url")){
      inputHelpText = document.getElementById("web-page-url-help-text"); 
    }

    if(failedValidation){
      inputField.style.borderColor="#dc3545"
      if(inputHelpText){
        if(inputField.getAttribute("data-is-abc-url") && failedABCUrlValidation){
          // TODO: Only show accepted web urls if the user inputs an invalid one.
          document.getElementById('web-page-options').hidden = false;
        }
          inputHelpText.classList.add('highlight-help-text');
      }
      return false
    } else {
        if(inputHelpText){
          if(inputField.getAttribute("data-is-abc-url")){
            document.getElementById('web-page-options').hidden = true;
          }
            inputHelpText.classList.remove('highlight-help-text');
        }
      return true
    }
  }

  
function noSpacesValidation(value) {
    var regex = /^\S*$/;
  
    var match = value.match(regex);
  
    if(match !== null){
        return true;
    } else {
        return false;
    }
  }
  
// Validates inputs that cannot have special characters or spaces if it is a no-space field
function noSpecialCharacterValidation(value) {
    var regex = /^[_A-z0-9]*((-|\s)*[_A-z0-9])*$/g;

    var match = value.match(regex);

    if(match !== null){
        return true;
    } else {
        return false;
    }
}

// Validates inputs that cannot have special characters or spaces, but can have underscores and hyphens.
function alphanumericUnderscoreHyphenValidation(value) {
  var regex = /^[_A-z0-9-_]*((-|\s)*[_A-z0-9-_])*$/g;

  var match = value.match(regex);

  if(match !== null){
      return true;
  } else {
      return false;
  }
}


function isValidURL(url) {
  if (questionMarkCount(url) > 1) {
    return false;
  }

  // '#' character can break anchor tag functionality, so it is disallowed.
  if (url.includes('#')) {
    return false;
  }

  return true;
}


function isValidABCURL(url) {
    var regex = /^https:\/\/(info\.abchomes\.com\.au)/i;

    if (url.match(regex)) {
    // the user input starts with 'https://info.abchomes.com.au'

      return true;
    } 

    regex = /^https:\/\/(abchomes\.com\.au)+/i;
    
    if (url.match(regex)) {
      // the user input starts with 'https://www.abchomes.com.au'
  
        return true;
    } 
      
    regex = /^https:\/\/(www\.abchomes\.online)+/i;

    if (url.match(regex)) {
      // the user input starts with 'https://abchomes.online'

        return true;
    } else {
      return false;
    }
}

function questionMarkCount(url) {
    var regex = /(\?)/gi;

    var regexMatch = url.match(regex);

    if (regexMatch !== null) {
    // there are multiple 'question mark' characters in the URL
    return regexMatch.length;
    } else {
    return 0;
    }
}

export default {validateForm};